import { gql } from '@apollo/client';

export const TOOL_BOOKING_THREAD = gql`
  query ToolBookingThread($id: ID!) {
    toolBooking(id: $id) {
      id
      messageThread {
        id
        subject
        messages {
          id
          content
          sentAt
          sender {
            id
            name
          }
        }
      }
    }
  }
`;
